import { render, staticRenderFns } from "./CompanyOmsDetail.vue?vue&type=template&id=57beef02&scoped=true&"
import script from "./CompanyOmsDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyOmsDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOmsDetail.vue?vue&type=style&index=0&id=57beef02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57beef02",
  null
  
)

export default component.exports